// src/fontAwesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDownload,
  faHeart,
  faComment,
  faTimes,
  faHome,
  faImages,
  faCogs,
  faCog,
  faList,
  faBars,
  faArrowLeft,
  faArrowRight,
  faPowerOff,
  faCodeCompare,
  faInfinity,
  faSpinner,
  faFolder,
  faFolderOpen,
  faEdit,
  faCoins,
  faPlus,
  faEllipsisV,
  faCheckToSlot,
  faCopy,
  faUpload,
  faHistory,
  faChartLine,
  faFilter,
  faMoon,
  faSun,
  faChevronDown,
  faChevronUp,
  faExclamationTriangle,
  faTriangleExclamation,
  faCircleInfo,
  faVideo,
  faTrash,
  faBolt,
  faWandMagicSparkles,
  faLink,
  faCloudArrowDown,
  faCloudArrowUp,
  faArrowUpRightFromSquare,
  faGaugeSimpleHigh,
  faClock,
  faFire,
  faStar,
  faSync,
  faShieldHalved,
  faExpand,
  faEye,
  faEyeSlash,
  faCircleExclamation,
  faCircleCheck,
  faArrowDown,
  faMagnifyingGlass,
  faPaperPlane,
  faCheck,
  faRedo,
  faGift,
  faFileContract,
  faBalanceScale,
  faShieldAlt,
  faShoppingCart,
  faIdCard,
  faChartPie,
  faFileInvoiceDollar,
  faBuilding,
  faCrown,
  faReceipt,
  faGlobe,
  faFilm,
  faArrowsLeftRight,
  faXmark,
  faPlay,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faDownload,
  faHeart,
  faComment,
  faTimes,
  faHome,
  faImages,
  faCogs,
  faCog,
  faList,
  faBars,
  faArrowLeft,
  faArrowRight,
  faPowerOff,
  faCodeCompare,
  faInfinity,
  faSpinner,
  faFolder,
  faFolderOpen,
  faEdit,
  faCoins,
  faPlus,
  faEllipsisV,
  faCheckToSlot,
  faCopy,
  faUpload,
  faHistory,
  faChartLine,
  faFilter,
  faMoon,
  faSun,
  faChevronDown,
  faChevronUp,
  faExclamationTriangle,
  faTriangleExclamation,
  faCircleInfo,
  faVideo,
  faTrash,
  faBolt,
  faWandMagicSparkles,
  faLink,
  faCloudArrowDown,
  faCloudArrowUp,
  faArrowUpRightFromSquare,
  faGaugeSimpleHigh,
  faClock,
  faFire,
  faStar,
  faSync,
  faShieldHalved,
  faExpand,
  faEye,
  faEyeSlash,
  faCircleExclamation,
  faCircleCheck,
  faArrowDown,
  faMagnifyingGlass,
  faPaperPlane,
  faCheck,
  faRedo,
  faGift,
  faFileContract,
  faBalanceScale,
  faShieldAlt,
  faShoppingCart,
  faIdCard,
  faChartPie,
  faFileInvoiceDollar,
  faBuilding,
  faCrown,
  faReceipt,
  faGlobe,
  faFilm,
  faArrowsLeftRight,
  faXmark,
  faPlay,
);
